export class EjercicioModel {
    documentContainerId?: string;
    documentId?: string;
    activo: boolean;
    nombre1: string;
    nombre2: string;
    tipo: string;
    nivel : string;
    mecanica: string;
    equipo: string;
    musculo: string;
    otros: string[];
    tags: string[];
    
    posicionInicial: string;
    descripcion : string;
    notas: string;

    imagenPosicionInicial?: {
        nombre: string;
        url: string;
    };
    imagenPosicionFinal?: {
        nombre: string;
        url: string;
    };

    linkVideo: string;
    linksAdicionales: string[];
    propietario: string;
    empresaId: string;
}

export const tiposEjercicios: string[] = [
    'Boxeo',
    'Calentamiento',
    'Cardiovascular',
    'Estiramiento',
    'Fuerza',
    'Isométrico',
    'Otro',
    'Pliométrico',
    'Relajación',
    'Suspensión',
];
export const musculosEjercicios: string[] = [
    'Abdominales',
    'Abductores',
    'Aductores',
    'Antebrazo',
    'Bíceps',
    'Cuádriceps',
    'Cuello',
    'Espalda Alta',
    'Espalda Baja',
    'Espalda Media',
    'Femorales',
    'General',
    'Glúteos',
    'Hombros',
    'Manguito Rotador',
    'Oblicuos',
    'Pantorrillas',
    'Pecho',
    'Serratos',
    'Tibiales',
    'Trapecio',
    'Tríceps',
];
export const nivelesEjercicios: string[] = [
    'Todos',
    'Intermedio',
    'Avanzado'
];
export const mecanicasEjercicios: string[] = [
    'Aislamiento',
    'Compuesto'
];
export const equiposEjercicios: string[] = [
    'Banca de hiperextensiones',
    'Banca declinada',
    'Banca inclinada',
    'Banca plana',
    'Bandas',
    'Barra alta fija',
    'Barra olímpica',
    'Barra recta',
    'Barra T',
    'Barra Z',
    'Cables',
    'Cables - Argollas',
    'Cables - Barra larga',
    'Cables - Barra recta corta',
    'Cables - Barra V corta',
    'Cables - Barra V larga',
    'Cables - Barra V mediana',
    'Cables - Barra V para tríceps',
    'Cables - Barra Z corta',
    'Cables - Grilletes',
    'Cables - Trenza',
    'Costal',
    'Disco de pesas',
    'Ligas',
    'Mancuernas',
    'Máquina',
    'Ninguno',
    'Otro',
    'Pelota de ejercicio',
    'Pelota medicinal',
    'Pera fija',
    'Pera loca',
    'Pesa rusa',
    'Silla romana',
    'Smith',
    'Varios'
];
